import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { BatchIcon } from '../batches';
import './JobBatch.scss';

const JobBatch = ({ value, history }) => {
  const handleClick = () => {
    history.push({ pathname: '/batch/list', state: { selectedBatchId: value } });
  };
  return (
    <div className="grb-jobbatch">
      {value && (
        <Tooltip title="Batch specification">
          <div>
            <IconButton
              aria-label="NavigateToBatch"
              onClick={handleClick}
            >
              <BatchIcon />
            </IconButton>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

JobBatch.propTypes = {
  value: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

JobBatch.defaultProps = {
  value: undefined,
};

export default JobBatch;

